import { createLocalizedPathnamesNavigation } from 'next-intl/navigation'
import { Locale } from './types/locale'

export const pathnames = {
  //Default HPP paths
  '/payment-not-found': '/payment-not-found',
  '/payin/[uuid]': '/payin/[uuid]',
  '/payin/[uuid]/pay': '/payin/[uuid]/pay',
  '/payin/[uuid]/seen': '/payin/[uuid]/seen',
  '/payin/[uuid]/done': '/payin/[uuid]/done',
  '/payin/[uuid]/expired': '/payin/[uuid]/expired',
  '/payin/[uuid]/cancelled': '/payin/[uuid]/cancelled',
  '/payin/[uuid]/device-checks-failed': '/payin/[uuid]/device-checks-failed',
  '/payout/[uuid]': '/payout/[uuid]',
  '/payout/[uuid]/seen': '/payout/[uuid]/seen',
  '/payout/[uuid]/done': '/payout/[uuid]/done',
  '/payout/[uuid]/expired': '/payout/[uuid]/expired',
  '/payout/[uuid]/cancelled': '/payout/[uuid]/cancelled',
  '/payout/[uuid]/device-checks-failed': '/payout/[uuid]/device-checks-failed',
  '/channel/[uuid]': '/channel/[uuid]',
  //Trustly paths
  '/payin/[uuid]/review': '/payin/[uuid]/review',
  '/payin/[uuid]/sign-in': '/payin/[uuid]/sign-in',
  '/payin/[uuid]/in-progress': '/payin/[uuid]/in-progress',
  '/payin/[uuid]/completed': '/payin/[uuid]/completed',
}

export const { Link, redirect, usePathname, useRouter } = createLocalizedPathnamesNavigation({
  locales: Object.values(Locale),
  pathnames: pathnames,
})
